const addinConfig = {
    getConfig: function() {
        var config = {};

        if (Office.context.roamingSettings) {
            config.username = Office.context.roamingSettings.get('tpaasUserName');
            config.password = Office.context.roamingSettings.get('tpaasPassword');
            config.locale = this.getLocale();
        }
        return config;
    },

    getLocale: function() {
        var locale = Office.context.displayLanguage;
        if (locale === undefined)
            return 'es';
        return locale.split('-')[0];
    },

    setConfig: function (config) {
        if (Office.context.roamingSettings) {
            Office.context.roamingSettings.set('tpaasUserName', config.username);
            Office.context.roamingSettings.set('tpaasPassword', config.password);

            Office.context.roamingSettings.saveAsync();
        }
    },

    eraseConfig: function () {
        addinConfig.setConfig({username: '', password: ''});
        /*if (Office.context.roamingSettings) {
            Office.context.roamingSettings.remove('tpaasUserName');
            Office.context.roamingSettings.remove('tpaasPassword');
        }*/
    }
};

export default addinConfig;


// WEBPACK FOOTER //
// ./src/helpers/addin-config.js